import {
    AfterContentInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef,
    forwardRef,
    Input,
    OnDestroy,
    QueryList,
    ViewChild,
} from '@angular/core';
import {CustomFormComponent} from 'app/shared/classes/custom-form-component';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {ListOptionComponent} from 'app/shared/components/drop-down-list/list-option/list-option.component';
import {Observable, Subject, Subscription} from 'rxjs';
import {DropDownComponent} from 'app/shared/components/drop-down/drop-down.component';
import {trackByProperty} from 'app/core/helpers/trackby';
import {queryListToObservable} from 'app/core/helpers/observable';
import {DimensionList} from 'app/features/analytics/features/reports/dimension';

export interface DropDownOption {
    icon?: string;
    label?: string;
    value: any;
}

@Component({
    selector: 'inline-select',
    templateUrl: './inline-select.component.html',
    styleUrls: ['./inline-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InlineSelectComponent),
            multi: true,
        },
    ],
})
export class InlineSelectComponent extends CustomFormComponent implements OnDestroy, AfterContentInit {
    @Input() typeDate: string;
    @ViewChild('dropDown', {static: false}) dropDown: DropDownComponent;
    @ViewChild('optionsWrapper', {static: false}) optionsWrapper: ElementRef<HTMLDivElement>;
    @ContentChildren(ListOptionComponent, {descendants: true}) listOptions: QueryList<ListOptionComponent>;
    options$: Observable<Array<DropDownOption>>;
    optionsSubject$ = new Subject<Array<DropDownOption>>();

    private currentlySelected: DropDownOption;
    private optionsSubscription = Subscription.EMPTY;
    private readonly emptyObject: DropDownOption;
    lastOptionsValue: Array<DropDownOption>;

    useIcons = false;
    searchQuery: string;
    showDropdown = false;

    trackByValue = trackByProperty<DropDownOption>('value');

    placeholderSelect() {
        let getLabel = DimensionList.find(e => e.id === this.typeDate)?.label;
        return getLabel === undefined ? '' : getLabel;
    }

    constructor(cd: ChangeDetectorRef, $el: ElementRef<HTMLElement>) {
        super($el, cd);
    }

    ngAfterContentInit() {
        this.options$ = queryListToObservable(this.listOptions);
        this.optionsSubscription = this.options$.subscribe(options => {
            this.lastOptionsValue = options;
            this.optionsSubject$.next(options);
            this.updateOptions(options);
            // if (!options.find(opt => opt.value === this.currentlySelected)) {
            this.currentlySelected = null;
            // }
            this.cd.markForCheck();
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.optionsSubscription.unsubscribe();
    }

    isSelected(option: DropDownOption) {
        return option.value === this.internalValue;
    }

    getSelected() {
        if (!this.currentlySelected) {
            this.currentlySelected = this.getSelectedOption(this.internalValue) || this.emptyObject;
        }
        return this.currentlySelected;
    }

    private updateOptions(options: Array<DropDownOption>) {
        this.useIcons = options.some(option => !!option.icon);
    }

    private getSelectedOption(value = this.internalValue) {
        if (Array.isArray(this.lastOptionsValue) && this.lastOptionsValue.length) {
            let listedOption = this.lastOptionsValue.find(option => option.value === value);
            if (listedOption) {
                return listedOption;
            }
        }
        return this.emptyObject;
    }

    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }

    private getOptionValue(option: DropDownOption) {
        return option && option.value;
    }

    onOptionClick(option: DropDownOption) {
        this.currentlySelected = null;
        this.invokeChangeCallback(this.getOptionValue(option));

        this.showDropdown = false;
    }
}
